import type { ReactNode } from "react";
import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/shared/uikit/Button";
import { useWidgetNavigate } from "@circle-react/components/HelpWidget/hooks/useWidgetNavigate";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface PreviewCardLayoutProps {
  children: ReactNode;
  title: string;
  url: string;
}

export const PreviewCardLayout = ({
  title,
  url,
  children,
}: PreviewCardLayoutProps) => {
  const navigate = useWidgetNavigate();

  return (
    <div
      className="bg-primary border-primary flex w-[368px] min-w-0 flex-1 flex-col items-start gap-3 self-stretch rounded-2xl border p-4"
      style={{ boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}
    >
      <Typography.BodySm weight="font-bold" color="text-dark">
        {title}
      </Typography.BodySm>

      {children}

      <Button onClick={() => navigate(url)} variant="circle" className="w-full">
        <Typography.BodySm weight="font-medium" color="text-primary">
          {t("help_widget.copilot.chat_card.preview_button")}
        </Typography.BodySm>
      </Button>
    </div>
  );
};
